// tslint:disable
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class FunctionsProvider {
  constructor() {}
  onMidia(e){
    return new Promise (resolve => {
      let midia={}
      var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
      var reader = new FileReader();
      reader.onloadend = function () {
        midia={
          name : file.name,
          type_midia : file.name.substring(file.name.lastIndexOf('.') + 1),
          midia: reader.result
        };
      resolve(midia);
      }
      if (file) {
        reader.readAsDataURL(file);
      } else {
        console.log ('Não existe arquivo')
      }
  })
 }
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/providers/functions/functions.ts